import DomainModel from '../domain-model';
import WorkerQueue from '../control-flow/worker-queue';
import { encodeModelType, ThumbnailRenderRequest } from './thumbnail-render-common';


const pool = new WorkerQueue<ThumbnailRenderRequest, string>('/js/thumbnail-render-worker.js');

export const renderObjectURL = (
    model: DomainModel, width: number = 128, height: number = 128)
        : [jobId: number, promise: Promise<string>] =>
{
    return pool.submit({
        width,
        height,
        modelType: encodeModelType(model),
        modelJSON: model.toJSON(),
    }, 0);
}

export const bumpJobPriority = (jobId: number) => {
    pool.bump(jobId);
}
